import { TopupPackageDetailModel } from "api/repositories/packagesManagement/topupManagement/model/detail/TopupDetailReponseModel"
import { ServiceDetailResponseModel } from "api/repositories/service/model/detail/ServiceDetailResponseModel"
import { SimResponseModel } from "api/repositories/simManagement/models/SimResponseModel"
import { UserManagementResponseModel } from "api/repositories/userManagement/model/UserManagementResponse"

export interface AppTransactionResponseModel {
  createdAt?: string,
  updatedAt?: string,
  id?: string,
  type?: number,
  status?: number,
  code?: string,
  name?: string,
  transRef?: string,
  totalAmount?: string | number,
  description?: string,
  note?: string,
  order?: number
  ownerId?: string,
  user?: UserManagementResponseModel,
  paymentMethod?: PaymentMethodModel,
  service?: ServiceDetailResponseModel,
  transactionDetail?: TransactionDetailModel,
  product?: ProductModel,
  paymentMethods?: PaymentMethodModel,
  platform?: string
}

interface PaymentMethodModel {
  createdAt?: string,
  updatedAt?: string,
  id?: string,
  name?: string,
  displayName?: string,
  code?: string,
  description?: string,
  cover?: string,
  url?: string,
  configuration?: Object,
  items?: Object,
  type?: number,
  status?: number,
  supplier?: string
}

export interface ProductModel {
  name?: string,
  code?: string,
  totalAmount?: string | number,
  type?: number,
  detail?: {
    createdAt?: string,
    updatedAt?: string,
    id?: string,
    name?: string,
    code?: string,
    status?: number,
    type?: number,
    description?: string,
    config?: string,
    order?: number,
    amount?: string,
    carrier?: string,
    totalAmount?: string,
    phoneNumber?: string,
    serial?: string,
    note?: string,
    sortDescription?: any
    simType?: number,
    sim?: SimResponseModel,
    mobileData?: TopupPackageDetailModel
  }
}

interface TransactionDetailModel {
  createdAt?: string,
  updatedAt?: string,
  id?: string,
  name?: string,
  code?: string,
  description?: string,
  order?: number,
  type?: number,
  status?: number,
  note?: string,
  info?: {
    totalAmount?: number,
    discountRate?: number,
    discountAmount?: number,
    amount?: Array<{
      value?: number,
      name?: string
    }>
  },
  buyer?: UserManagementResponseModel
}

export enum TransactionStatusEnum {
  Init = 0,
  Proccess = 1,
  Success = 2,
  Failed = 3,
  Pending = 4,
  PaymentSuccess = 5,
  Timeout = 6,
  Deleted = 7
}

export enum TransactionTypeEnum {
  Normal = 0,
  User = 1,
  Partner = 2
}